import { store } from '@betacrew/jars-flux'
export const componentKey = "EDIT_PROFILE";

const { actions } = store.reducerManager.add({
	key: componentKey,
	addedReducers: {
		setUserInfo: (state, action) => {
			state.userInfo = { ...action.payload };
		},
		setLoadingState: (state, action) => {
			state.loadingState = action.payload;
		},
		setChangeProfileInfo: (state, action) => {
			state.changeProfileInfo = action.payload;
		},
		setSelectedCountry: (state, action) => {
			state.selectedCountry = { ...action.payload };
		},
		setIsEmailValid: (state, action) => {
			state.isEmailValid = action.payload;
		},
		setResetForm: (state, action) => {
			state.resetForm = action.payload;
		}
	},
	initialReducerState: {
		userInfo: {
			Email: "",
			FirstName: "",
			LastName: "",
			CountryCode: "",
			PhoneNumber: "",
			CompanyName: ""
		},
		loadingState: false,
		changeProfileInfo: false,
		editEmail: false,
		selectedCountry: { code: "US", label: "United States", value: "+1" },
		isEmailValid: true,
		resetForm: false,
	}
});
export const { setUserInfo, setLoadingState, setChangeProfileInfo, setSelectedCountry, setIsEmailValid, setResetForm } = actions;